import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-527e2498"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "panel-title" }, "表头设置"),
  /*#__PURE__*/_createElementVNode("span", { class: "panel-subtitle" }, "（可拖动调整顺序）")
], -1))
const _hoisted_2 = { class: "panel-content" }
const _hoisted_3 = {
  class: "column-tags",
  ref: "columnListRef"
}
const _hoisted_4 = ["onPointerdown"]
const _hoisted_5 = { class: "panel-footer" }
const _hoisted_6 = { class: "footer-left" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "reset-icon" }, "↺", -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 恢复默认 ")
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "footer-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "header-settings-overlay",
          ref: "overlayRef",
          onPointerdown: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleOverlayPointerDown && _ctx.handleOverlayPointerDown(...args)), ["self","prevent"]))
        }, [
          _createElementVNode("div", {
            class: "header-settings-panel",
            ref: "panelRef",
            style: _normalizeStyle(_ctx.panelCompensateStyle),
            onPointerdown: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
          }, [
            _hoisted_1,
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localColumns, (col, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: col.key,
                    class: _normalizeClass(["column-tag", {
                                placeholder: _ctx.isDragging && _ctx.dragIndex === index,
                                'drop-target': _ctx.isDragging && _ctx.hoverIndex === index && _ctx.hoverIndex !== _ctx.dragIndex
                            }]),
                    onPointerdown: ($event: any) => (_ctx.handlePointerDown($event, index))
                  }, _toDisplayString(col.title), 43, _hoisted_4))
                }), 128))
              ], 512)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", {
                  class: "reset-btn",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleReset && _ctx.handleReset(...args)))
                }, _hoisted_9)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  class: "btn btn-cancel",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleCancel && _ctx.handleCancel(...args)))
                }, "取消"),
                _createElementVNode("button", {
                  class: "btn btn-apply",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleApply && _ctx.handleApply(...args)))
                }, "应用")
              ])
            ])
          ], 36)
        ], 544))
      : _createCommentVNode("", true)
  ]))
}